interface Events {
    [key: string]: (() => void)[]
}

export class UIEventEmitter {
    events: Events

    constructor(events: Events = {}) {
        this.events = events
    }

    subscribe(name: string, callback: (...args: any[]) => void) {
        if(this.events[name] == undefined) {
            this.events[name] = []
        }
        this.events[name].push(callback)

        return {
            unsubscribe: () => this.unsubscribe(name, callback),
        }
    }

    subscribeOnce(name: string, callback: (...args: any[]) => void) {
        const listener = this.subscribe(name, (...args: any[]) => {
            listener.unsubscribe()
            callback.apply(null, [...args])
        })
    }

    listenerCount(name: string): number {
        if(this.events[name] == undefined) {
            return 0
        }
        return this.events[name].length
    }

    unsubscribe(name: string, callback: (...args: any[]) => void) {
        if(this.events[name] == undefined) {
            return
        }
        this.events[name] = this.events[name].filter((event) => event !== callback)
    }

    emit(name: string, ...args: any[]) {
        if(this.events[name] == undefined) {
            return
        }
        this.events[name].forEach((eventCallback) => eventCallback.apply(null, [...args]))
    }
}
